import React, { useState } from 'react';
import { LuChevronDown } from 'react-icons/lu';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const faqData: FAQItem[] = [
    {
      question: "What is Loan Against Securities (LAS)?",
      answer: "Loan Against Securities (LAS) allows you to pledge financial securities like Mutual Funds and Shares as collateral to borrow funds, retaining ownership while accessing liquidity without selling investments."
    },
    {
      question: "What is Loan-to-Value (LTV) in LAS?",
      answer: "The Loan-to-Value (LTV) ratio for Loan Against Securities (LAS) is capped at 50% for shares and equity Mutual Funds, as per RBI guidelines. For debt mutual funds, it may go up to 80%."
    },
    {
      question: "What is the Interest Rate for LAS?",
      answer: "The interest rate for Loan Against Securities (LAS) ranges from 10.5% to 12.5%, depending on the loan amount and tenure. For Loan Against Mutual Funds (LAMF), the interest rate is fixed at 10.5%."
    },
    {
      question: "What are the benefits of partnering with Lark Finserv?",
      answer: "Partnering with Lark Finserv provides numerous benefits, including: Partner branded Site, Partner Unique Link, Competitive Commission, Convenience & Flexibility, 100% Digital Loan Experience, Fastest Disbursals, Branding & Credibility. These benefits empower you to better serve your clients while growing your business."
    },
    {
      question: "What is LISA (Lark Intelligence Support Assistance)?",
      answer: "LISA is our AI-powered chatbot, specifically designed to deliver instant support and assistance for all customer inquiries, ensuring quick responses and enhancing the overall customer experience with Lark Finserv."
    },
    {
      question: "How can I check my loan eligibility?",
      answer: "To check your loan eligibility, visit Check Eligibility on Lark's website. The process is free and does not affect your credit score."
    },
    {
      question: "What factors determine my eligibility?",
      answer: "Your loan eligibility is determined by factors including a minimum investment of Rs 50,000 in Mutual Funds, clear ownership of securities, age between 18 to 65 years, and the type of Mutual Funds from an approved list."
    },
    {
      question: "Will checking eligibility affect my credit score?",
      answer: "No, checking your loan eligibility will not affect your credit score. The eligibility check is free and does not involve a hard inquiry, ensuring that your credit score remains unaffected while you assess your loan options."
    },
    {
      question: "How long does the eligibility check take?",
      answer: "The eligibility check process is quick and typically takes only a few minutes to complete. You can easily assess your eligibility by visiting Lark’s website and following the application process without any impact on your credit score."
    },
    {
      question: "What if I’m not eligible?",
      answer: "If you’re not eligible for a loan, you can explore other financial options or work on improving your securities portfolio. Additionally, you may check your eligibility again in the future as your financial situation changes."
    },
    {
      question: "What is a Loan Against Mutual Funds?",
      answer: "A Loan Against Mutual Funds allows investors to borrow funds by pledging their mutual fund holdings as collateral. This provides liquidity without selling investments, enabling access to cash while retaining ownership of the mutual funds for various purposes."
    },
    {
      question: "How much loan can I get against my mutual funds?",
      answer: "You can get a loan of up to 45% of the current value of equity mutual funds and 70-80% for debt mutual funds. The minimum loan amount is Rs 50,000, with a maximum limit of Rs 5 crore."
    },
    {
      question: "How do I apply for a Loan Against Mutual Funds?",
      answer: "To apply for a Loan Against Mutual Funds, click on 'Get loan' on Lark's website, provide your details, verify with OTP, check eligibility, and set up your loan limit against your securities. The process takes less than 10 minutes."
    },
    {
      question: "What are the interest rates for the Loan Against Mutual Fund?",
      answer: "The interest rates for a Loan Against Mutual Funds typically range from 10.5% to 12.5% annually. The specific rate depends on the loan amount and tenure, ensuring competitive pricing for borrowers seeking liquidity against their mutual fund investments."
    },
    {
      question: "Will my mutual funds be affected if I take a loan?",
      answer: "Yes, your mutual funds will be affected if you take a loan against them. They will be pledged as collateral, and if you default, the lender may liquidate your mutual funds to recover the outstanding loan amount."
    }
  ];
  

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl p-5">
      <h2 className="text-3xl font-bold mb-8">
        Frequently Asked Questions
      </h2>
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div 
            key={index} 
            className="border border-gray-200 rounded-lg overflow-hidden"
          >
            <button 
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center p-4 text-left 
                         bg-white hover:bg-gray-100 transition-colors duration-300
                         focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <span className="font-semibold text-gray-800">{faq.question}</span>
              <LuChevronDown 
                className={`h-6 w-6 text-emerald-600 transform transition-transform duration-300 
                            ${activeIndex === index ? 'rotate-180' : ''}`} 
              />
            </button>
            
            <div 
              className={`grid transition-all duration-300 ease-in-out 
                          ${activeIndex === index 
                            ? 'grid-rows-[1fr] opacity-100 visible' 
                            : 'grid-rows-[0fr] opacity-0 invisible h-0'}`}
            >
              <div className="overflow-hidden">
                <div className="p-4 bg-gray-50 text-gray-700">
                  {faq.answer}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;